import React, {useMemo} from "react"

import PropTypes from "prop-types"
import {Checkbox, Radio} from "semantic-ui-react"

import {getDataTestId} from "../../utils/stringUtil"
import ButtonTertiary, {BUTTON_TERTIARY_VARIANTS} from "../ButtonTertiary/buttonTertiary"

import "./style.scss"

export const OPTION_TILE_VARIANTS = {DEFAULT: "default", CHECKBOX: "checkbox", RADIO_LARGE: "radio-large"}

const OptionTile = ({
    actions,
    children,
    disabled = false,
    hiddenContent,
    onClick,
    rightContent,
    selected = false,
    subTitle,
    title,
    variant = OPTION_TILE_VARIANTS.DEFAULT,
}) => {
    const isRadioLargeVariant = useMemo(() => variant === OPTION_TILE_VARIANTS.RADIO_LARGE, [variant])

    return (
        <div
            aria-label={title}
            className={`option-tile variant-${variant}${selected ? " selected" : ""}${disabled ? " disabled" : ""}`}
            data-testid={getDataTestId(title, "option")}
            onClick={onClick}
            tabIndex={0}
        >
            {/* Header */}
            {!isRadioLargeVariant && (
                <div className="option-tile-header">
                    {variant === OPTION_TILE_VARIANTS.CHECKBOX ? (
                        <Checkbox checked={selected} disabled={disabled} tabIndex={-1} />
                    ) : (
                        <Radio checked={selected} disabled={disabled} tabIndex={-1} />
                    )}
                    <div>
                        <label>{title}</label>
                        {subTitle && <p>{subTitle}</p>}
                    </div>
                </div>
            )}

            {/* Contenu principal */}
            {(isRadioLargeVariant || children) && (
                <div className="option-tile-content">
                    {/* Bouton radio */}
                    {isRadioLargeVariant && <Radio checked={selected} disabled={disabled} tabIndex={-1} />}

                    {/* Body */}
                    {
                        <div className="option-tile-body">
                            {isRadioLargeVariant && <label>{title}</label>}
                            {children}
                        </div>
                    }

                    {/* Element affiché à droite */}
                    {isRadioLargeVariant && <div>{rightContent}</div>}
                </div>
            )}

            {/* Contenu visible seulement si la tuile est selectionnée */}
            {isRadioLargeVariant && selected && hiddenContent && <div>{hiddenContent}</div>}

            {/* Actions */}
            {!isRadioLargeVariant && actions && (
                <div className="option-tile-actions">
                    {actions.map(action => (
                        <ButtonTertiary
                            disabled={disabled}
                            icon={action.icon}
                            onClick={action.onClick}
                            variant={action.variant ? action.variant : undefined}
                        >
                            {action.label}
                        </ButtonTertiary>
                    ))}
                </div>
            )}
        </div>
    )
}

OptionTile.propTypes = {
    actions: PropTypes.arrayOf(
        PropTypes.shape({
            icon: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
            onClick: PropTypes.func.isRequired,
            variant: PropTypes.oneOf(Object.values(BUTTON_TERTIARY_VARIANTS)),
        }),
    ),
    children: PropTypes.node,
    disabled: PropTypes.bool,
    hiddenContent: PropTypes.node,
    onClick: PropTypes.func.isRequired,
    rightContent: PropTypes.node,
    selected: PropTypes.bool,
    subTitle: PropTypes.string,
    title: PropTypes.string.isRequired,
    variant: PropTypes.oneOf(Object.values(OPTION_TILE_VARIANTS)),
}

export default OptionTile
